export { DiningReservationV2Connected as DiningReservationV2 } from './DiningReservationV2.container';
export { DiningV2Connected as DiningV2 } from './DiningV2.container';
